import React from 'react';
import { getDetectedDevice } from '../../../../utils/device-detection';
import { ellipsis } from '../../../../utils/ellipsis';
import PositiveSymbolIcon from '../../../../../public/static/icons/plus.svg';
import NegativeSymbolIcon from '../../../../../public/static/icons/minus.svg';

import { SvgIcon } from '@mui/material';
import { StyledArrowIcon } from '../../../sections/highlights/highlights.style';
import {
    StyledReviewComment,
    StyledCommentParaGraph,
    StyledShowMoreBtn,
} from './ugc-review-item.style';
import { theme } from '../../../../style/global-style';
import { IUGCReviewCommentProps, Device } from '@interfaces';
import { useToggleContentScroll } from '../../../../hooks/useToggleContentScroll';

const renderSVGIcon = (iconType: string): React.ReactNode => {
    if (iconType === 'positive') {
        return <PositiveSymbolIcon />;
    } else if (iconType === 'negative') {
        return <NegativeSymbolIcon />;
    } else {
        return null;
    }
};
export const UGCReviewComment = ({ comment, iconType }: IUGCReviewCommentProps) => {
    const device: Device = getDetectedDevice();
    const reviewDescRef = React.createRef<HTMLParagraphElement>();
    const { isCollapsed, toggleCollapse, maxHeightReviewContent } = useToggleContentScroll(
        reviewDescRef,
    );
    const charLimit = 280;
    const normalizedText =
        comment && isCollapsed && device === 'desktop' ? ellipsis(comment, charLimit) : comment;
    return (
        <>
            {normalizedText ? (
                <StyledReviewComment>
                    {iconType && (
                        <SvgIcon style={{ fontSize: 15, color: theme.shades.darkGrey }}>
                            {renderSVGIcon(iconType)}
                        </SvgIcon>
                    )}
                    <StyledCommentParaGraph
                        ref={reviewDescRef}
                        isCollapsed={isCollapsed}
                        scrollContentHeight={maxHeightReviewContent}
                    >
                        {normalizedText}{' '}
                        {normalizedText && normalizedText.length > charLimit ? (
                            <StyledShowMoreBtn
                                onClick={toggleCollapse}
                                aria-expanded={!isCollapsed}
                                data-testid="toggle-comment-btn"
                            >
                                {/* @TODO: add translations */}
                                {isCollapsed ? `mehr anzeigen` : `weniger anzeigen`}{' '}
                                <StyledArrowIcon isCollapsed={isCollapsed} />
                            </StyledShowMoreBtn>
                        ) : null}
                    </StyledCommentParaGraph>
                </StyledReviewComment>
            ) : null}
        </>
    );
};
